import { useEffect } from 'react'
import { useAppSettings } from '../contexts/AppSettingsContext'
import { usePublicAppInfo } from './usePublicAppInfo'
import { useAuth } from '../contexts/AuthContext'

export const useDocumentTitle = (pageTitle?: string) => {
  const { user } = useAuth()
  const { settings } = useAppSettings()
  const { appInfo } = usePublicAppInfo()

  useEffect(() => {
    // Folosim settings doar dacă utilizatorul este autentificat
    // Altfel folosim informațiile publice
    const appName = user && settings?.app_name 
      ? settings.app_name 
      : appInfo?.app_name || 'SynpRIS'
    
    if (pageTitle) {
      document.title = `${pageTitle} - ${appName}`
    } else {
      document.title = `${appName} - Sistem de Informații Radiologice`
    }
  }, [user, settings?.app_name, appInfo?.app_name, pageTitle])

  return null
}
